import { DEFAULT_LOGO_SIZE } from '../../../../api/constants'
import gaEvents from '~js/ga-events'
import {
  addParameter,
  tryAsync
} from '~js/utils'
import router from '@/router/index'
import BuildingsManager from '../../manager/buildings-manager'
import buildingApiService from '../../../../services/api/building'
import i18n from '@/i18n'

const setTripodLogo = tryAsync(async (building) => {
  const logo = await buildingApiService.fetchLogo(building.objectId)
  if (logo) {
    building.logo = logo.logoUrl || null
    building.logoSize = logo.logoSize || DEFAULT_LOGO_SIZE
  }
  return building
})

const shouldSetBuildingNotShow = (building) => {
  const noShow = building.isOffline || building.unavailable
  if (noShow) {
    console.log('should the building not show', building.objectId)
  }
  return noShow
}

const setPanoramasRelations = building => {
  building.panoramas.forEach(panorama => {
    panorama.buildingId = building.objectId
  })
  return building
}

const formatBuildingData = (building) => ({
  advertiseLink: building.advertiseLink,
  bookings: building.bookings ? JSON.parse(building.bookings) : {},
  calendar: building.calendar,
  description: building.description || '',
  objectId: building.objectId,
  createdAt: building.createdAt,
  updatedAt: building.updatedAt,
  name: building.name || '',
  logoSize: building.logoSize,
  showComment: building.showComment,
  showContactInfo: building.showContactInfo,
  showPoweredBy: building.showPoweredBy,
  themeColor: building.themeColor,
  unavailable: building.unavailable,
  mapEnable: building.mapEnable,
  requireVisitorData: building.requireVisitorData,
  requireWhiteListing: building.requireWhiteListing,
  whiteList: building.whiteList || [],
  tourRingBtn: building.tourRingBtn,
  compass: building.compass,
  thumbnail: building.thumbnail,
  music: building.music || '',
  nameMulti: building.nameMulti ? JSON.parse(building.nameMulti) : {},
  descriptionMulti: building.descriptionMulti ? JSON.parse(building.descriptionMulti) : {},
  floorplan: building.floorplan || '',
  floorplanSize: building.floorplanSize || 0,
  productNumber: building.productNumber || null,
  markerFinderEnable: building.markerFinderEnable,
  ownerId: building.Owner.objectId,
  geoLatitude: building.geoLatitude,
  geoLongitude: building.geoLongitude,
  myFavoriteEnable: building.myFavoriteEnable,
  meta: building.meta || {},
  introAssetsEnable: building.introAssetsEnable,
  introAssetsAttribute: building.introAssetsAttribute ? JSON.parse(building.introAssetsAttribute) : {},
  instantMessagingEnable: building.instantMessagingEnable
})

const formatBuilding = (building) => {
  building = formatBuildingData(building)
  if (building.thumbnail) {
    building.thumbnail = addParameter(building.thumbnail, `n=${Math.random()}`)
  }
  if (building.floorplan) {
    building.floorplan = addParameter(building.floorplan, `n=${Math.random()}`)
  }
  if (building.logo) {
    building.logo = addParameter(building.logo, `n=${Math.random()}`)
  }
  return building
}

const state = {
  // only property has buildings; Single building won't use this
  groupBuildings: [],
  currentBuilding: {}
}

export const getters = {
  currentBuilding: state => state.currentBuilding,
  groupBuildings: state => state.groupBuildings,
  showComment: state => state.currentBuilding.showComment,
  showSearch: state => state.currentBuilding.showSearch,
  showContactInfo: state => state.currentBuilding.showContactInfo,
  showPoweredBy: state => state.currentBuilding.showPoweredBy,
  logoSize: state => state.currentBuilding.logoSize,
  floorplan: state => state.currentBuilding.floorplan
}

export const actions = {

  async fetchBuilding ({ dispatch, commit, state, rootState }, buildingId = '') {
    // It's the same building, no need to fetch it again
    if (buildingId === state.currentBuilding.objectId) return
    if (buildingId === '') return BuildingsManager.noBuildingCallback({ dispatch, commit, state, rootState })
    dispatch('setProgressCount', 0)
    dispatch('showProgress')

    /* Detail visitor tracking - reset session on building start fetching */
    dispatch('visitorHistory/resetViewSession')

    const building = await buildingApiService.fetchBuilding(buildingId)
    // if (the building id is not existed || the building has no panorama)
    if (!building || !building.panoramas.length) {
      return BuildingsManager.noBuildingCallback({ dispatch, commit, state, rootState })
    }
    // building = formatBuilding(building)
    dispatch('setBuilding', building)
  },

  async setBuilding ({ dispatch, commit, state, rootState }, building) {
    const userId = building.ownerId

    // Whether building is public or unpublic , all buildings can get headquarter
    await dispatch('fetchPublicProfile', userId)
    const buildingId = building.objectId
    let nameMulti = {}
    nameMulti = typeof building.nameMulti === 'string'
      ? JSON.parse(building.nameMulti)
      : typeof building.nameMulti === 'object' ? building.nameMulti : {}
    document.title = nameMulti[i18n.locale] || building.name || 'VR Viewer'
    if (shouldSetBuildingNotShow(building)) {
      BuildingsManager.noBuildingCallback({ dispatch, commit, state, rootState })
      return
    }
    // harcode wea buildings are unavailable before Wed Mar 10 2021 10:00:00 GMT+0800 (台北標準時間) except testmode
    if (building.ownerName && building.ownerName.startsWith('WEA') && Date.now() < 1615341600000 && !rootState.route.query.testmode) {
      BuildingsManager.noBuildingCallback({ dispatch, commit, state, rootState })
      return
    }
    // set panorama store data
    const panoramas = setPanoramasRelations(building).panoramas
    // init progress count with unreal number
    dispatch('addProgressCount', 0)
    dispatch('setProgressMax', 100)
    building = formatBuilding(building)
    building = await setTripodLogo(building)
    commit('SET_BUILDING', building)
    await dispatch('setPanoramas', panoramas)
    commit('SET_USER_ID', userId)
    // if (rootState.user.user.objectId !== userId) {
    // }
    await BuildingsManager.afterFetchProfileHandler({ dispatch, building, buildingId })

    dispatch('setBuildingNotFound', false)
    dispatch('initUiMode')
    BuildingsManager.initAudio({ dispatch, rootState, building })
    BuildingsManager.initThemeColor({ dispatch, rootState, building })
    gaEvents.init()

    /* Detail visitor tracking - start session on building switched */
    dispatch('visitorHistory/startViewSession', buildingId)
  },

  selectBuilding ({ state, rootState }, { buildingId = '', index = 1, panorama = '' }) {
    if ((buildingId === state.currentBuilding.objectId) ||
      rootState.progress.isProgressActive ||
      ((rootState.app.isBuildingNotFound || rootState.app.isNoPanoramasFound) && !rootState.krpano.isKrpanoActive)) {
      return
    }
    const propertyId = rootState.route.query.group || ''
    const query = Object.assign({}, rootState.route.query, { index })
    if (panorama) {
      query.panorama = panorama
    }
    router.push({
      path: buildingId,
      query
    })
    gaEvents.sendEvent('Property', 'ChangeBuilding', propertyId)
    // Next step will go to pages/Default/index.vue beforeRouteUpdate() method
    // Why don't I write here? Because user might go back to previous page, I must handle the situation
  }
}

export const mutations = {
  SET_GROUP_BUILDINGS (state, buildings = []) {
    state.groupBuildings = buildings
  },

  SET_BUILDING (state, building = {}) {
    state.currentBuilding = building
  },

  SET_SHOW_SEARCH (state, openSearch) {
    state.showSearch = openSearch
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
